import type { ReactNode } from 'react';
import { createContext } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

const draggableBackend = {
  html5: HTML5Backend,
  touch: TouchBackend,
};

const DraggableContext = createContext<
  { backendType: keyof typeof draggableBackend } | undefined
>(undefined);

export const DraggableProvider = ({
  children,
  type = 'html5',
}: {
  children: ReactNode;
  type?: keyof typeof draggableBackend;
}) => {
  return (
    <DndProvider
      context={window}
      backend={draggableBackend[type]}
      options={{ enableMouseEvents: true }}
    >
      <DraggableContext.Provider value={{ backendType: type }}>
        {children}
      </DraggableContext.Provider>
    </DndProvider>
  );
};
